import { useCallback, useEffect, useRef } from 'react';
import ReactCanvasConfetti from 'react-canvas-confetti';

// function randomInRange(min, max) {
//   return Math.random() * (max - min) + min;
// }

const canvasStyles = {
  position: 'absolute',
  pointerEvents: 'none',
  width: '100%',
  height: '100%',
  top: '0',
  left: '0',
  zIndex: '999',
};

function getAnimationSettings() {
  return {
    startVelocity: 30,
    spread: 2000,
    // ticks: 60,
    zIndex: 0,
    // particleCount: 150,
    particleCount: 700,
    origin: {
      x: 0.5, // Center X
      y: 0, // Center Y
    },
  };
}
// function getAnimationSettings(originXA, originXB) {
//   return {
//     startVelocity: 30,
//     spread: 360,
//     ticks: 60,
//     zIndex: 0,
//     particleCount: 150,
//     origin: {
//       x: randomInRange(originXA, originXB),
//       y: Math.random() - 0.2,
//     },
//   };
// }

// eslint-disable-next-line react/prop-types
export default function Fireworks({ trigger }) {
  const refAnimationInstance = useRef(null);

  const getInstance = useCallback((instance) => {
    refAnimationInstance.current = instance;
  }, []);

  const triggerFireworks = useCallback(() => {
    if (refAnimationInstance.current && trigger) {
      refAnimationInstance.current(getAnimationSettings(0.1, 0.3));
      refAnimationInstance.current(getAnimationSettings(0.7, 0.9));
    }
  }, [trigger]);

  // for infinite trigger also remove prop part 1
  // const nextTickAnimation = useCallback(() => {
  //   if (refAnimationInstance.current) {
  //     refAnimationInstance.current(getAnimationSettings(0.1, 0.3));
  //     refAnimationInstance.current(getAnimationSettings(0.7, 0.9));
  //   }
  // }, []);

  useEffect(() => {
    triggerFireworks();
  }, [trigger, triggerFireworks]);

  // for infinite trigger also remove prop part 2
  // useEffect(() => {
  //   const intervalId = setInterval(nextTickAnimation, 1200);

  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, [nextTickAnimation]);

  return <ReactCanvasConfetti refConfetti={getInstance} style={canvasStyles} />;
}
